<template>
  <v-app>
   
    <v-app-bar v-if="isIOS" app color="white" flat dense></v-app-bar>
    <v-main>
      <v-alert
        v-if="alertControl.show && this.$store.state.ui.online"
        type="warning"
        dense
        :icon="false"
        class="alert-permission text-center"
      >
        {{ alertControl.msg }}
      </v-alert>
      <v-app-bar :app="!isIOS" dense flat color="deep-purple accent-4" dark class="notranslate">
      
        <v-btn icon v-if="backActive" @click.prevent="backState">
          <v-icon>mdi-arrow-left-bold</v-icon>
        </v-btn>

        <v-btn icon to="/chat" v-if="chatActive">
          <v-badge
            v-if="newMessages > 0"
            offset-y="12"
            color="red"
            :content="newMessages"
          >
            <v-icon class="__shake">mdi-message-text-outline</v-icon>
          </v-badge>
          <v-icon v-else>mdi-message-text-outline</v-icon>
        </v-btn>

        <v-spacer></v-spacer>

        <v-toolbar-title>
          <v-img
            height="40px"
            :src="logo"
            width="180px"
            @click.prevent="redirectHome"
          />
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <offline />
        <v-app-bar-nav-icon @click.stop="drawer = !drawer"></v-app-bar-nav-icon>
      </v-app-bar>

      <!-- NAV -->
      <v-navigation-drawer v-model="drawer" absolute temporary class="notranslate drawer-modern">
        <!-- Profile Header -->
        <div class="drawer-header">
          <div class="profile-section" @click="$router.push('/profile'); drawer = false">
            <v-avatar size="56" class="profile-avatar">
              <v-img v-if="profilePictureUrl" :src="profilePictureUrl"></v-img>
              <v-icon v-else size="32" color="white">mdi-account</v-icon>
            </v-avatar>
            <div class="profile-info">
              <span class="profile-name">{{ user.firstName }} {{ user.lastName }}</span>
              <span class="profile-email">{{ user.email }}</span>
            </div>
            <v-icon class="profile-arrow" size="20" color="#999">mdi-chevron-right</v-icon>
          </div>
        </div>

        <!-- Menu Items -->
        <div class="drawer-content">
          <nav class="menu-list">
            <a class="menu-item" @click="$router.push('/profile'); drawer = false">
              <v-icon class="menu-icon" size="22">mdi-account-outline</v-icon>
              <span class="menu-text">{{ $t("home.profile") }}</span>
            </a>

            <a
              v-if="!isIOS"
              class="menu-item"
              :class="{ 'menu-disabled': !avaibleChatSupport }"
              @click="redirectHelpDesk"
            >
              <v-icon class="menu-icon" size="22">mdi-help-circle-outline</v-icon>
              <span class="menu-text">{{ $t("home.txtHelpSupport") }}</span>
            </a>

            <a class="menu-item" @click="$router.push('/select-unit'); drawer = false">
              <v-icon class="menu-icon" size="22">mdi-car-outline</v-icon>
              <span class="menu-text">{{ $t("home.txtSelectUnit") }}</span>
            </a>

            <a class="menu-item" @click="checkUpdate">
              <v-icon class="menu-icon" size="22">mdi-refresh</v-icon>
              <span class="menu-text">{{ $t("home.txtButtomUpdate") }}</span>
              <v-progress-circular
                v-if="loadingUpdate"
                size="16"
                width="2"
                color="#666"
                indeterminate
                class="ml-2"
              ></v-progress-circular>
            </a>

            <div class="menu-divider"></div>

            <a class="menu-item menu-logout" @click="closedSession">
              <v-icon class="menu-icon" size="22">mdi-logout</v-icon>
              <span class="menu-text">{{ $t("home.logout") }}</span>
            </a>
          </nav>

          <!---LIVE TRACKER-->
          <LiveTracker/>
          <!---LIVE TRACKER-->

          <!-- Unit Info Card -->
          <div v-if="user.currentTransportUnit" class="unit-card">
            <div class="unit-header">
              <v-icon size="18" color="#666">mdi-car</v-icon>
              <span>{{ $t("home.txtUnit") }}</span>
            </div>
            <div class="unit-details">
              <div class="unit-row">
                <span class="unit-label">{{ $t("home.txtLicense") }}</span>
                <span class="unit-value">{{ user.licenseNumber }}</span>
              </div>
              <div class="unit-row">
                <span class="unit-label">{{ $t("home.txtUnit") }}</span>
                <span class="unit-value">{{ user.currentTransportUnit.name }}</span>
              </div>
              <div class="unit-row">
                <span class="unit-label">{{ $t("home.txtPlates") }}</span>
                <span class="unit-value">{{ user.currentTransportUnit.plateNumber }}</span>
              </div>
            </div>
          </div>
        </div>

        <!-- Footer -->
        <div class="drawer-footer">
          <btnInstall v-if="showPwaModule"></btnInstall>
          <span class="version-text">{{ appVersion }}</span>
        </div>
      </v-navigation-drawer>
      <!-- END NAV -->

      <router-view class="mb-12 full-h" />
    </v-main>

    <div class="bottom-nav-modern" v-if="activeNav">
      <div class="nav-container">
        <button
          v-for="(item, index) in itemsNav"
          :key="index"
          class="nav-btn"
          :class="{ 'nav-btn-active': selectedItem === index }"
          @click.prevent="actionNavigation(item, index)"
        >
          <v-icon class="nav-icon" :size="20">{{ item.icon }}</v-icon>
          <span class="nav-label">{{ item.name }}</span>
        </button>
      </div>
    </div>

    <!-- Lector del QR -->
    <qrreader :onlyEvent="onlyEvent" :select="qrSelect" />

    <!-- Dialogo de progreso -->
    <v-dialog
      v-model="dialogLoading"
      persistent
      width="200"
      dark
      class="loadingBlock"
    >
      <v-card color="deep-purple accent-4" dark>
        <v-card-text class="pt10">
          <span class="text-white">{{ $t("home.waiting") }}...</span>
          <v-progress-linear
            indeterminate
            color="white"
            class="mt-1"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>

    <!-- Notification -->
    <v-snackbar v-model="snackbarActive">
      {{ textSnackbar }}

      <template v-slot:action="{ attrs }">
        <v-btn color="blue" text v-bind="attrs" @click="closedNotification">
          {{ $t("global.snackbar.close") }}
        </v-btn>
      </template>
    </v-snackbar>

    <!-- Alert Dialog -->
    <v-dialog v-model="alertDialogActive" persistent max-width="320" content-class="alert-dialog-modern">
      <div class="alert-dialog-container">
        <div class="alert-dialog-header">
          <div class="alert-icon" :class="alertDialogType">
            <v-icon size="28" :color="alertIconColor">{{ alertIcon }}</v-icon>
          </div>
          <h3 class="alert-title">{{ alertDialogTitle }}</h3>
          <p class="alert-message">{{ alertDialogMessage }}</p>
        </div>
        <div class="alert-dialog-actions">
          <button class="alert-btn" :class="alertBtnClass" @click="closeAlertDialog">
            {{ $t("global.dialog.btnToAccept") }}
          </button>
        </div>
      </div>
    </v-dialog>

  </v-app>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from "vuex";
import logo from "@/assets/logo-sc-blanco.svg";
import { auth, firestore, messaging } from "../plugins/firebase.js";
import store from "@/store";
import { PushNotifications } from "@capacitor/push-notifications";
import { Capacitor as CapacitorApp } from "@capacitor/core";
import { FCM } from "@capacitor-community/fcm";
import chatProvider from "../plugins/helper-chat.js"
const qrreader = () =>
  import(/* webpackChunkName: "qrreader" */ "@/components/QRReader.vue");
/*import { Intercom } from "@mathieustan/vue-intercom";*/
import LiveTracker from "../components/liveTrackerWithWatchPosition.vue";
const offline = () =>
  import(/* webpackChunkName: "Offline" */ "@/components/Offline.vue");
import btnInstall from "../components/pwaInstallBtn";
export default {
  name: "Home",
  components: { qrreader, offline,LiveTracker,btnInstall },
  data: () => ({
    drawer: false,
    loading: false,
    logo,
    selected: 0,
    listener: null,
    autoAuth: null,
    //watchID: null,
    userData: {
      userId: "",
      name: "",
      email: "",
    },
    /*intercom: new Intercom({ appId: "b6mt6y88" }),*/
    avaibleChatSupport: false,
    selectItemMenu: null,
    appVersion: process.env.PWA_APP_VERSION,
    showPwaModule:true,
    loadingUpdate:false
  }),
  computed: {
    ...mapState("auth", {
      user: (state) => state.user,
    }),
    ...mapState("ui", {
      activeNav: (state) => state.navigation.active,
      itemsNav: (state) => state.navigation.items,
      selectedItem: (state) => state.navigation.IndexItemActive,
      backActive: (state) => state.backActive,
      chatActive: (state) => state.chatActive,
      qrActive: (state) => state.qr.active,
      dialogLoading: (state) => state.core.dialogLoading,
      onlyEvent: (state) => state.qr.onlyEvent,
      qrSelect: (state) => state.qr.select,
      textSnackbar: (state) => state.snackbar.text,
      alertDialogTitle: (state) => state.alertDialog.title,
      alertDialogMessage: (state) => state.alertDialog.message,
      alertDialogType: (state) => state.alertDialog.type,
    }),
    ...mapState("chat", {
      roomsChat: (state) => state.activeChats,
    }),
    ...mapState({
      lang: (state) => state.lang,
      registration: (state) => state.registration,
      gpsGranted:(state)=>state.gpsGranted
    }),
    ...mapGetters(["isIOS"]),
    profilePictureUrl() {
      return this.user?.profilePictureUrl || null;
    },
    driverId() {
      return store.state.auth.user.id;
    },
    yesterday() {
      return this.$moment()
        .utc(-5)
        .subtract(1, "days");
    },
    newMessages() {
      return this.roomsChat.filter(function(item) {
        return item.haveMessages;
      }).length;
    },
    snackbarActive: {
      get: function() {
        return this.$store.state.ui.snackbar.active;
      },
      set: function() {
        this.closedSnackbar();
      },
    },
    alertControl(){
      return {
        show:!this.gpsGranted,
        msg:this.$t("global.gpsRequiredAlert")
      }
    },
    alertDialogActive: {
      get: function() {
        return this.$store.state.ui.alertDialog.active;
      },
      set: function() {
        this.hideAlert();
      },
    },
    alertIcon() {
      const icons = {
        success: 'mdi-check-circle',
        error: 'mdi-alert-circle',
        info: 'mdi-information',
      };
      return icons[this.alertDialogType] || icons.info;
    },
    alertIconColor() {
      const colors = {
        success: '#4caf50',
        error: '#c62828',
        info: '#6200ea',
      };
      return colors[this.alertDialogType] || colors.info;
    },
    alertBtnClass() {
      return `alert-btn-${this.alertDialogType}`;
    }
  },
  methods: {
    ...mapMutations("ui", {
      selectNavigationItem: "selectNavigationItem",
      closedSnackbar: "closedSnackbar",
      onlineEvent: "onlineEvent",
    }),
    ...mapMutations("chat", {
      orderRoomsChat: "orderChats",
    }),
    ...mapActions("auth", { logout: "logout" }),
    ...mapActions("ui", {
      resetQR: "resetQR",
      hideAlert: "hideAlert",
    }),
    ...mapActions("services", {
      resetService: "resetService",
    }),
    checkUpdate() {
      this.loadingUpdate=true
      navigator.serviceWorker.getRegistration().then((registration) => {
        if (registration) {
          registration.update(); // 🔁 Triggers a check for updated SW on the server
        }
      }).finally(()=>{
        setTimeout(() => {
          this.loadingUpdate=false;
        }, 1000);
      });
    },
    closedNotification() {
      this.closedSnackbar();
    },
    closeAlertDialog() {
      this.hideAlert();
    },
    backState() {
      if (window.history.length > 2) {
        this.$router.back();
      } else {
        this.$router.push({ name: "Home" });
      }
    },
    redirectHelpDesk() {
      // this.$router.push({ name: "helpdesk" });
      this.intercom.show();
    },
    redirectHome() {
      if (this.$route.name !== "Home") {
        this.$router.push({ name: "Home" });
        this.selectNavigationItem(0);
      } else if (this.selectedItem != 0) {
        this.selectNavigationItem(0);
      }
    },
    closedSession() {
      this.resetQR();
      this.resetService();
      this.logout();
      localStorage.clear();
      auth.signOut();
      this.$router.push({ name: "Login" });
    },
    actionNavigation(item, index) {
      if (item.type === "action" && item.action) {
        item.action();
      } else if (item.type === "component") {
        this.selectNavigationItem(index);
      }
    },
    observableAuth() {
      auth.onAuthStateChanged((user) => {
        if (user) {
          if (user.uid !== "driver-" + this.driverId) {
            //protegemos la sesion (si no coincide deslogueamos)
            this.closedSession();
          }
        } else {
          //no logueado
          this.$axios
            .get(`driver/auth/chat/${this.driverId}`)
            .then((resToken) => {
              let token = resToken.data.token;
              auth.signInWithCustomToken(token).catch((err) => {
                console.log("No login auto" + err);
                this.closedSession();
              });
            });
        }
      });
    },
    getLasMessage(roomDoc) {
      return new Promise((success) => {
        roomDoc.ref
          .collection("messages")
          .orderBy("createdAt", "desc")
          .limit(1)
          .get()
          .then((_messages) => {
            success(_messages.docs[0].data());
          })
          .catch(() => {
            success("");
          });
      });
    },

    fillMessageItem(snap) {
      let room = snap.doc;
      let data = room.data();

      let item = {
        serviceNumber: data.serviceNumber,
        client: data.client,
        id: data.room,
        title: "#" + data.room,
        subtitle: "",
        haveMessages: data.clientNewMessage ?? false,
        action: "",
        lastUpdated: data.lastUpdated,
        time: "0",
        avatar: "https://cdn.vuetifyjs.com/images/lists/5.jpg",
      };

      this.getLasMessage(room).then((lastMessage) => {
        try {
          if (lastMessage !== "") {
            item.subtitle = lastMessage.content ?? "";
            item.action = lastMessage.createdAt;
            item.time = lastMessage.createdAt.toDate();
          }
        } catch (err) {
          console.log(err);
        }
      });

      return item;
    },
    initFirebaseChat() {
      this.autoAuth = this.observableAuth();
      this.listener = firestore
        .collection("chats")
        .where("members.driver", "==", this.driverId)
        .where("lastUpdated", ">", new Date(this.yesterday))
        .orderBy("lastUpdated", "desc")
        .onSnapshot({ includeMetadataChanges: true }, (snap) => {
          let _cuantos = snap.docChanges().length;
          snap.docChanges().forEach((change) => {
            switch (change.type) {
              case "added": //si empiezan una nueva conversacion
                this.roomsChat.push(this.fillMessageItem(change));
                break;
              case "removed":
                this.deleteRoomFromView(change.doc);
                break;
              case "modified":
                this.updateRoom(change);
                break;
              default:
                console.log();
                break;
            }
            if (--_cuantos <= 0) {
              this.orderRoomsChat();
            }
          });
          this.isLoading = false;
          return Promise.resolve();
        });
    },
    deleteRoomFromView(snap) {
      let id_room = snap.data().room;
      this.roomsChat.forEach((element, i) => {
        if (element.id == id_room) {
          this.roomsChat.splice(i, 1);
        }
      });
    },
    updateRoom(snap) {
      let id_room = snap.doc.data().room;
      let roomFound = this.roomsChat.find((_item) => {
        return _item.id == id_room;
      });
      if (roomFound) {
        let newItem = this.fillMessageItem(snap);
        Object.assign(roomFound, newItem);
        this.getLasMessage(snap.doc).then((message) => {
          try {
            roomFound.subtitle = message.content ?? "";
            roomFound.action = message.createdAt;
          } catch (err) {
            console.log(err);
          }
        });
      }
    },

    checkRoute() {
      store.state.ui.chatActive = true;
      switch (this.$route.name) {
        case "ListChat":
          store.state.ui.chatActive = false;
          break;
      }
    },
    async initPushnotificationWeb(){
      await messaging
						.getToken({
							vapidKey: process.env.VUE_APP_FCM_VAPID
						})
						.then(fcmToken => {
							//actualizamos el token del cliente
							try {
								if (fcmToken) {
                  firestore
                  .collection("drivers")
                  .doc(String(this.driverId))
                  .set({ token: fcmToken });
								} else {
									console.log(
										"No registration token available. Request permission to generate one."
									);
								}
								return;
							} catch (error) {
								console.log("Error generating token " + error);
								return;
							}
        });
    },
    initPushMessaging() {
      PushNotifications.requestPermission().then(async (permission) => {
        if (permission.receive === "granted") {
          // Register with Apple / Google to receive push via APNS/FCM
          await PushNotifications.register();
        } else {
          // No permission for push granted
        }
      });
      // On success, we should be able to receive notifications
      PushNotifications.addListener("registration", (token) => {
        // Enable the auto initialization of the library
        FCM.setAutoInit({ enabled: true });
        // Check the auto initialization status
        FCM.isAutoInitEnabled();
        FCM.getToken()
          .then((fcmToken) => {
            if (fcmToken) {
              firestore
                .collection("drivers")
                .doc(String(this.driverId))
                .set({ token: token.value });
            } else {
              console.log(
                "No registration token available. Request permission to generate one."
              );
            }
          })
          .catch((err) => console.log("Error generating token" + err));
      });
      // Some issue with our setup and push will not work
      PushNotifications.addListener("registrationError", (error) => {
        console.log("Error on registration: " + JSON.stringify(error));
      });

      // Method called when tapping on a notification
      var self = this;
      PushNotifications.addListener(
        "pushNotificationActionPerformed",
        (event) => {
          let serviceId = "";
          try {
            serviceId = event.notification.data.url.split("/chat/")[1];
            if (serviceId.length > 0) {
              self.$router.push({
                name: "Chat",
                params: {
                  id: serviceId,
                },
              });
            }
          } catch (err) {
            console.log("err " + err);
          }
        }
      );
    },
    startIntercomMessenger(user) {
      if (!this.intercom.ready) {
        this.intercom.once("ready", () => this.rebootIntercom(user));
      } else {
        this.rebootIntercom(user);
      }
    },
    rebootIntercom(user) {
      this.avaibleChatSupport = true;
      this.intercom.shutdown();

      if (this.intercom.isBooted) return;
      this.intercom.boot(user);
    },
    onlineOffline() {
      window.addEventListener("offline", () => {
        console.log("event")
        this.onlineEvent(false);
      });

      window.addEventListener("online", () => {
        console.log("event online")
        this.onlineEvent(true);
      });
    },
    initHelperChat(user) {
			if (user) {
				chatProvider.identify(user);
				//chatProvider.start();
				//this.chatStarted = true;
			}
		},
  },
  mounted() {
    this.userData = {
      userId: this.user.id,
      name: `${this.user.firstName} ${this.user.lastName}`,
      email: this.user.email,
      supplier_name: this.user.supplierName,
      hide_default_launcher: true,
    };

    // Tomar el estado actual
    if (navigator.onLine) {
      this.onlineEvent(true);
    } else {
      this.onlineEvent(false);
    }

    this.onlineOffline();
    /*this.startIntercomMessenger(this.userData);*/
    this.initHelperChat(this.userData)
    this.initFirebaseChat();
    if (CapacitorApp.getPlatform() != "web") {
      this.initPushMessaging();
    }else{
      this.initPushnotificationWeb();
    }
    this.checkRoute();
  },
  destroyed() {
    if (this.listener) {
      this.listener(); //off
    }
    if (this.autoAuth) {
      this.autoAuth(); //off
    }
    store.state.chat.activeChats = [...[]];
  },
  watch: {
    $route() {
      this.checkRoute();
    },
  },
};
</script>

<style scoped>
.full-h {
  height: 100%;
}
.text-white {
  color: #fff;
}
.pt10 {
  padding-top: 13px !important;
}
</style>

<style scoped>
	/* Animation property */
.__shake {
    animation: wiggle 2s linear infinite;
}
/* Keyframes */
@keyframes wiggle {
    0%,
    7% {
        transform: rotateZ(0);
    }
    15% {
        transform: rotateZ(-15deg);
    }
    20% {
        transform: rotateZ(10deg);
    }
    25% {
        transform: rotateZ(-10deg);
    }
    30% {
        transform: rotateZ(6deg);
    }
    35% {
        transform: rotateZ(-4deg);
    }
    40%,
    100% {
        transform: rotateZ(0);
    }
}

/* Modern Bottom Navigation */
.bottom-nav-modern {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background: #ffffff;
  padding: 8px 12px 12px;
  box-shadow: 0 -2px 16px rgba(0, 0, 0, 0.06);
  z-index: 100;
}

.nav-container {
  display: flex;
  gap: 8px;
  width: 100%;
  overflow-x: auto;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
  -ms-overflow-style: none;
}

.nav-container::-webkit-scrollbar {
  display: none;
}

.nav-btn {
  flex: 1 1 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 4px;
  padding: 10px 8px;
  border: none;
  background: #f5f5f7;
  border-radius: 12px;
  cursor: pointer;
  transition: all 0.2s ease;
  min-width: 70px;
}

.nav-btn:active {
  transform: scale(0.96);
}

.nav-icon {
  color: #666 !important;
  transition: color 0.2s ease;
}

.nav-label {
  font-size: 11px;
  font-weight: 500;
  color: #666;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 100%;
  transition: color 0.2s ease;
}

.nav-btn-active {
  background: linear-gradient(135deg, #6200ea 0%, #7c4dff 100%);
  box-shadow: 0 4px 12px rgba(98, 0, 234, 0.3);
}

.nav-btn-active .nav-icon {
  color: #fff !important;
}

.nav-btn-active .nav-label {
  color: #fff;
  font-weight: 600;
}

/* Modern Drawer Styles */
.drawer-modern {
  background: #fafafa !important;
}

.drawer-header {
  background: #fff;
  padding: 16px;
  border-bottom: 1px solid #eee;
}

.profile-section {
  display: flex;
  align-items: center;
  gap: 12px;
  cursor: pointer;
  padding: 6px;
  margin: -6px;
  border-radius: 10px;
  transition: background 0.2s ease;
}

.profile-section:active {
  background: #f5f5f5;
}

.profile-avatar {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  flex-shrink: 0;
}

.profile-info {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 1px;
}

.profile-name {
  font-size: 15px;
  font-weight: 600;
  color: #1a1a1a;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-email {
  font-size: 12px;
  color: #888;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.profile-arrow {
  flex-shrink: 0;
}

.drawer-content {
  padding: 10px 8px;
  flex: 1;
}

.menu-list {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.menu-item {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 11px 14px;
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.15s ease;
  text-decoration: none;
  color: inherit;
}

.menu-item:active {
  background: #f0f0f0;
  transform: scale(0.98);
}

.menu-icon {
  color: #555 !important;
  flex-shrink: 0;
}

.menu-text {
  font-size: 14px;
  font-weight: 500;
  color: #333;
}

.menu-disabled {
  opacity: 0.4;
  pointer-events: none;
}

.menu-divider {
  height: 1px;
  background: #e5e5e5;
  margin: 8px 14px;
}

.menu-logout .menu-icon {
  color: #c62828 !important;
}

.menu-logout .menu-text {
  color: #c62828;
}

.unit-card {
  background: #fff;
  border-radius: 10px;
  padding: 12px;
  margin-top: 12px;
  border: 1px solid #e5e5e5;
}

.unit-header {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 11px;
  font-weight: 600;
  color: #666;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
}

.unit-details {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.unit-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.unit-label {
  font-size: 12px;
  color: #888;
}

.unit-value {
  font-size: 12px;
  font-weight: 500;
  color: #333;
}

.drawer-footer {
  padding: 12px 16px;
  border-top: 1px solid #eee;
  background: #fff;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
}

.version-text {
  font-size: 11px;
  color: #999;
}

/* Alert Dialog Styles */
.alert-dialog-container {
  background: #fff;
  border-radius: 16px;
  overflow: hidden;
}

.alert-dialog-header {
  padding: 24px 20px 16px;
  text-align: center;
}

.alert-icon {
  width: 60px;
  height: 60px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0 auto 16px;
}

.alert-icon.success {
  background: #e8f5e9;
}

.alert-icon.error {
  background: #ffebee;
}

.alert-icon.info {
  background: #ede7f6;
}

.alert-title {
  font-size: 18px;
  font-weight: 600;
  color: #1a1a1a;
  margin: 0 0 8px;
}

.alert-message {
  font-size: 14px;
  color: #666;
  margin: 0;
  line-height: 1.5;
}

.alert-dialog-actions {
  padding: 8px 20px 20px;
}

.alert-btn {
  width: 100%;
  padding: 14px;
  border: none;
  border-radius: 10px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s ease;
}

.alert-btn:active {
  transform: scale(0.98);
}

.alert-btn-success {
  background: #4caf50;
  color: #fff;
}

.alert-btn-success:active {
  background: #43a047;
}

.alert-btn-error {
  background: #c62828;
  color: #fff;
}

.alert-btn-error:active {
  background: #b71c1c;
}

.alert-btn-info {
  background: #6200ea;
  color: #fff;
}

.alert-btn-info:active {
  background: #5000d0;
}

</style>

<style>
.alert-dialog-modern {
  border-radius: 16px !important;
  overflow: hidden;
}
.v-navigation-drawer--temporary {
  z-index: 99999 !important;
}
</style>
